import {useState} from "react";

import {
  initialMedicalOrganizationTagFormData,
  MedicalOrganizationTagFormData
} from "../components/MedicalOrganizationTags/MedicalOrganizationTags";

type SelectorItem = {
  name: string;
};

export const useMedicalOrganizationFilters = () => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedVaccine, setSelectedVaccine] = useState<string[]>([]);
  const [tagFormData, setTagFormData] = useState<MedicalOrganizationTagFormData>(initialMedicalOrganizationTagFormData);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const onChangeCategoriesSelector = (category: SelectorItem) => {
    setCurrentPage(1);
    setSelectedCategories((prev) =>
      prev.includes(category.name)
        ? prev.filter((c) => c !== category.name)
        : [...prev, category.name]
    );
  };

  const onChangeSelectedVaccine = (vaccine: SelectorItem) => {
    setCurrentPage(1);
    setSelectedVaccine((prev) =>
      prev.includes(vaccine.name)
        ? prev.filter((c) => c !== vaccine.name)
        : [...prev, vaccine.name]
    );
  };

  const onChangeTagFormData = (formData: MedicalOrganizationTagFormData) => {
    setCurrentPage(1);
    setTagFormData(formData);
  };

  return {
    searchTerm,
    setSearchTerm,
    selectedCategories,
    selectedVaccine,
    tagFormData,
    currentPage,
    setCurrentPage,
    onChangeCategoriesSelector,
    onChangeSelectedVaccine,
    onChangeTagFormData,
  };
};
